(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3091],{

/***/ 21876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ BlogCard_BlogCard; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./components/Typography/index.ts + 1 modules
var Typography = __webpack_require__(39181);
// EXTERNAL MODULE: ./components/BlogSection/BlogCard/BlogCard.module.scss
var BlogCard_module = __webpack_require__(53206);
var BlogCard_module_default = /*#__PURE__*/__webpack_require__.n(BlogCard_module);
// EXTERNAL MODULE: ./components/BlogSection/BlogImage/BlogImage.tsx
var BlogImage = __webpack_require__(64196);
;// CONCATENATED MODULE: ./components/BlogSection/BlogCard/BlogCard.tsx





var BlogCard = function(param) {
    var post = param.post, _noBorderRadius = param.noBorderRadius, noBorderRadius = _noBorderRadius === void 0 ? false : _noBorderRadius;
    // Function to check if body has actual content (not just empty HTML tags)
    var hasActualContent = function(htmlContent) {
        if (!htmlContent) return false;
        // Remove all HTML tags using regex (works in both client and server)
        var textContent = htmlContent.replace(/<[^>]*>/g, "");
        // Decode HTML entities
        var decodedContent = textContent.replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#39;/g, "'");
        // Remove all whitespace and check if there's actual content
        var cleanedContent = decodedContent.trim().replace(/\s+/g, " ");
        return cleanedContent.length > 0;
    };
    var hasBody = hasActualContent(post.body);
    var isClickable = hasBody && post.slug;
    var handleClick = function() {
        if (isClickable) {
            window.location.href = "/news/".concat(post.slug);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((BlogCard_module_default()).card, " ").concat(noBorderRadius ? (BlogCard_module_default()).noBorderRadius : "", " ").concat(isClickable ? (BlogCard_module_default()).clickable : (BlogCard_module_default()).notClickable),
        onClick: handleClick,
        role: isClickable ? "button" : undefined,
        tabIndex: isClickable ? 0 : undefined,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((BlogCard_module_default()).cardImage, " ").concat(noBorderRadius ? (BlogCard_module_default()).noBorderRadius : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogImage/* default */.Z, {
                    src: post.image,
                    alt: post.title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    isClickable && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BlogCard_module_default()).cardTags,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                variant: "text-xs",
                                as: "span",
                                className: (BlogCard_module_default()).tag,
                                style: {
                                    color: "#D6BBFB"
                                },
                                children: post.category
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                variant: "text-xs",
                                as: "span",
                                className: (BlogCard_module_default()).readTime,
                                style: {
                                    color: "#D6BBFB"
                                },
                                children: post.readTime
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BlogCard_module_default()).cardHeader,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                variant: "text-lg",
                                as: "h3",
                                color: "grayDark-50",
                                className: (BlogCard_module_default()).cardTitle,
                                children: post.title
                            }),
                            isClickable && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                                className: (BlogCard_module_default()).linkIcon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M4 12L12 4M4 4H12V12",
                                    stroke: "currentColor",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                        variant: "text-md",
                        as: "p",
                        color: "grayDark-400",
                        className: (BlogCard_module_default()).cardDescription,
                        children: post.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BlogCard_module_default()).cardAuthor,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (BlogCard_module_default()).authorAvatar,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: post.author.avatar,
                                    alt: post.author.name,
                                    width: 40,
                                    height: 40,
                                    loading: "lazy"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (BlogCard_module_default()).authorInfo,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                        variant: "text-sm",
                                        as: "span",
                                        color: "primary",
                                        weight: "medium",
                                        children: post.author.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                        variant: "text-sm",
                                        as: "span",
                                        color: "grayDark-400",
                                        children: post.author.date
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var BlogCard_BlogCard = (BlogCard);

;// CONCATENATED MODULE: ./components/BlogSection/BlogCard/index.ts



/***/ }),

/***/ 64196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57135);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15767);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);




// The blog carousel renders several clones of each slide for its infinite-loop
// effect (react-slick), so the same image src mounts multiple times. Without
// this cache, each mounted instance below would independently fetch() and
// blob the same remote image, multiplying network requests by the clone count.
var blobUrlCache = new Map();
var getCachedObjectUrl = function(src) {
    var entry = blobUrlCache.get(src);
    if (!entry) {
        entry = fetch(src, {
            method: "GET",
            credentials: "omit"
        }).then(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(response) {
                var blob, finalBlob, urlLower, mimeType;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!response.ok) throw new Error("Failed to fetch image: ".concat(response.status));
                            return [
                                4,
                                response.blob()
                            ];
                        case 1:
                            blob = _state.sent();
                            finalBlob = blob;
                            if (!blob.type || blob.type === "application/octet-stream") {
                                urlLower = src.toLowerCase();
                                mimeType = "image/jpeg";
                                if (urlLower.includes(".png")) mimeType = "image/png";
                                else if (urlLower.includes(".gif")) mimeType = "image/gif";
                                else if (urlLower.includes(".webp")) mimeType = "image/webp";
                                finalBlob = new Blob([
                                    blob
                                ], {
                                    type: mimeType
                                });
                            }
                            return [
                                2,
                                URL.createObjectURL(finalBlob)
                            ];
                    }
                });
            });
            return function(response) {
                return _ref.apply(this, arguments);
            };
        }());
        blobUrlCache.set(src, entry);
        entry.catch(function() {
            return blobUrlCache.delete(src);
        });
    }
    return entry;
};
var BlogImage = function(param) {
    var src = param.src, alt = param.alt, _className = param.className, className = _className === void 0 ? "" : _className, _fallbackSrc = param.fallbackSrc, fallbackSrc = _fallbackSrc === void 0 ? "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80" : _fallbackSrc;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(src), imageSrc = ref[0], setImageSrc = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), hasError = ref1[0], setHasError = ref1[1];
    var triedOriginalRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    // Try to load image as blob if it's from media/view API. The blob/object URL
    // itself is cached by src in getCachedObjectUrl above, so carousel clones of
    // the same slide share one network fetch instead of issuing one each.
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setHasError(false);
        triedOriginalRef.current = false;
        if (src && src.includes("/media/view?")) {
            var cancelled = false;
            getCachedObjectUrl(src).then(function(url) {
                if (!cancelled) setImageSrc(url);
            }).catch(function(error) {
                console.warn("Failed to load image as blob, using direct URL:", error);
                if (!cancelled) setImageSrc(src);
            });
            return function() {
                cancelled = true;
            };
        }
        setImageSrc(src);
    }, [
        src
    ]);
    var handleError = function() {
        if (hasError) return;
        // The shared object URL failed to render - try the original src once before
        // giving up on the remote image entirely.
        if (!triedOriginalRef.current && src && src !== imageSrc) {
            triedOriginalRef.current = true;
            setImageSrc(src);
            return;
        }
        console.warn("Image failed to load:", imageSrc);
        setHasError(true);
        setImageSrc(fallbackSrc);
    };
    var handleLoad = function() {
        setHasError(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        src: imageSrc,
        alt: alt,
        className: className,
        onError: handleError,
        onLoad: handleLoad,
        loading: "lazy"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogImage);


/***/ }),

/***/ 35283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ BlogSection_BlogSection; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(72006);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-awesome-reveal@4.3.1_@emotion+react@11.14.0_@types+react@18.0.21_react@18.2.0_sup_9ec67bc2838b979fc11a3db5ae856235/node_modules/react-awesome-reveal/dist/index.js + 2 modules
var dist = __webpack_require__(56399);
// EXTERNAL MODULE: ./components/BlogSection/BlogSection.module.scss
var BlogSection_module = __webpack_require__(79035);
var BlogSection_module_default = /*#__PURE__*/__webpack_require__.n(BlogSection_module);
// EXTERNAL MODULE: ./components/Typography/index.ts + 1 modules
var Typography = __webpack_require__(39181);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-slick@0.30.3_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-slick/lib/index.js
var lib = __webpack_require__(51156);
// EXTERNAL MODULE: ./node_modules/.pnpm/slick-carousel@1.8.1_jquery@4.0.0/node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(96410);
// EXTERNAL MODULE: ./node_modules/.pnpm/slick-carousel@1.8.1_jquery@4.0.0/node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(38337);
// EXTERNAL MODULE: ./components/Button/index.ts + 1 modules
var Button = __webpack_require__(32033);
// EXTERNAL MODULE: ./components/BlogSection/BlogCard/index.ts + 1 modules
var BlogCard = __webpack_require__(21876);
// EXTERNAL MODULE: ./utils/index.ts
var utils = __webpack_require__(95656);
;// CONCATENATED MODULE: ./components/BlogSection/BlogSection.tsx













// Helper function to format date as "18 Jan 2025"
var formatDate = function(dateString) {
    var date = new Date(dateString);
    var day = date.getDate();
    var monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec", 
    ];
    var month = monthNames[date.getMonth()];
    var year = date.getFullYear();
    return "".concat(day, " ").concat(month, " ").concat(year);
};
var BlogSection = function(param) {
    var _posts = param.posts, posts = _posts === void 0 ? [] : _posts;
    // Transform API data to component format
    var formatBlogPosts = function(apiPosts) {
        return apiPosts.map(function(post) {
            var ref, ref1, ref2;
            return {
                id: post._id,
                image: (0,utils/* formatBlogImageUrl */.a)((ref = post.coverImage) === null || ref === void 0 ? void 0 : ref.url),
                category: ((ref1 = post.categories) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.name) || "General",
                readTime: post.readingTime ? "".concat(post.readingTime, " min read") : "5 min read",
                title: post.title,
                description: post.summary || "Read more about this blog post.",
                author: {
                    name: "EPEN Team",
                    avatar: "/chat/chat-admin-avatar.png",
                    date: post.publishedAt ? formatDate(post.publishedAt) : formatDate(new Date().toISOString())
                },
                slug: post.slug,
                body: post.body
            };
        });
    };
    var blogPosts = formatBlogPosts(posts);
    var showCarousel = blogPosts.length > 2;
    var carouselSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.5
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    arrows: false
                }
            }, 
        ]
    };
    var handleViewAllPosts = function() {
        window.location.href = "/news";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (BlogSection_module_default()).blogSection,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (BlogSection_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Fade */.pT, {
                    triggerOnce: true,
                    duration: 800,
                    style: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (BlogSection_module_default()).header,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (BlogSection_module_default()).headerContent,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (BlogSection_module_default()).badge,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/blog-badge.svg",
                                                alt: "EPEN Ltd. Latest Writings and Blog Posts Badge",
                                                width: 48,
                                                height: 48,
                                                loading: "lazy"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (BlogSection_module_default()).headerText,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                    variant: "display-md",
                                                    as: "h2",
                                                    color: "primary",
                                                    className: (BlogSection_module_default()).title,
                                                    children: "Latest writings"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                    variant: "text-xl",
                                                    as: "p",
                                                    color: "grayDark-400",
                                                    className: (BlogSection_module_default()).description,
                                                    children: "The latest news, technologies, and resources from our team."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (BlogSection_module_default()).viewAllButtonInDesktop,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        variant: "primary",
                                        size: "md",
                                        fullWidth: true,
                                        onClick: handleViewAllPosts,
                                        label: "View all posts"
                                    })
                                })
                            ]
                        }),
                        showCarousel ? // Carousel for Desktop/Tablet (3+ posts)
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (BlogSection_module_default()).carouselWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, carouselSettings), {
                                className: (BlogSection_module_default()).carousel,
                                children: blogPosts.map(function(post, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                                        triggerOnce: true,
                                        duration: 600,
                                        delay: index * 100,
                                        style: {
                                            width: "100%"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCard/* default */.Z, {
                                            post: post
                                        })
                                    }, post.id);
                                })
                            }))
                        }) : // Simple Layout for 2 or less posts (Desktop/Tablet)
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (BlogSection_module_default()).simpleLayout,
                            children: blogPosts.map(function(post, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                                    triggerOnce: true,
                                    duration: 600,
                                    delay: index * 100,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCard/* default */.Z, {
                                        post: post
                                    })
                                }, post.id);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (BlogSection_module_default()).mobilePosts,
                    children: blogPosts.slice(0, showCarousel ? 2 : blogPosts.length).map(function(post, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                            triggerOnce: true,
                            duration: 600,
                            delay: index * 100,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCard/* default */.Z, {
                                post: post
                            })
                        }, post.id);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (BlogSection_module_default()).viewAllButtonInMobile,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        variant: "primary",
                        size: "md",
                        fullWidth: true,
                        onClick: handleViewAllPosts,
                        label: "View all posts"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var BlogSection_BlogSection = (BlogSection);

;// CONCATENATED MODULE: ./components/BlogSection/index.ts



/***/ }),

/***/ 95656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ formatBlogImageUrl; },
/* harmony export */   "cx": function() { return /* binding */ cx; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4814);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5466);


function cx() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_0__/* .twMerge */ .m6)((0,clsx__WEBPACK_IMPORTED_MODULE_1__/* .clsx */ .W)(inputs));
}
/**
 * Formats image URL for blog posts
 * If the URL is an S3 URL, it wraps it in the media view API endpoint
 * @param imageUrl - The image URL from the API
 * @returns Formatted image URL
 */ function formatBlogImageUrl(imageUrl) {
    if (!imageUrl) {
        return "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80";
    }
    // If it's already a media view URL, return as is
    if (imageUrl.includes("/media/view?")) {
        return imageUrl;
    }
    // If it's an S3 URL, wrap it in the media view API
    if (imageUrl.includes("vxfx-io.s3.eu-central-1.amazonaws.com") || imageUrl.includes("s3.eu-central-1.amazonaws.com")) {
        var encodedUrl = encodeURIComponent(imageUrl);
        return "https://api.vxfx.io/media/view?url=".concat(encodedUrl);
    }
    // If it's a direct API file path (like /1733110794800_xxx.webp or https://api.vxfx.io/1733110794800_xxx.webp)
    // These need to be wrapped in /media/view endpoint for Next.js Image to work
    if (imageUrl.startsWith("http") && imageUrl.includes("api.vxfx.io") && !imageUrl.includes("/media/view") || imageUrl.startsWith("/") && imageUrl.match(/\/\d+_[a-f0-9]+\.(jpg|jpeg|png|gif|webp|svg|avif)$/i)) {
        // If it's a relative path, make it absolute
        var absoluteUrl = imageUrl.startsWith("http") ? imageUrl : "https://api.vxfx.io".concat(imageUrl);
        var encodedUrl1 = encodeURIComponent(absoluteUrl);
        return "https://api.vxfx.io/media/view?url=".concat(encodedUrl1);
    }
    // For other URLs (like unsplash), return as is
    return imageUrl;
}


/***/ }),

/***/ 53206:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"BlogCard_card__Rtf5J","noBorderRadius":"BlogCard_noBorderRadius__Hkfyp","clickable":"BlogCard_clickable__V77H8","notClickable":"BlogCard_notClickable__OehVq","cardImage":"BlogCard_cardImage__iMhQW","cardTags":"BlogCard_cardTags__dPSo0","tag":"BlogCard_tag__6nCjW","readTime":"BlogCard_readTime__JCiRX","cardHeader":"BlogCard_cardHeader__7VsMl","cardTitle":"BlogCard_cardTitle__xMqRe","cardDescription":"BlogCard_cardDescription__xZi_p","linkIcon":"BlogCard_linkIcon__Y9iO7","cardAuthor":"BlogCard_cardAuthor__ye5Ff","authorAvatar":"BlogCard_authorAvatar__xqcXF","authorInfo":"BlogCard_authorInfo__dqOja"};

/***/ }),

/***/ 79035:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blogSection":"BlogSection_blogSection__Pa9i8","container":"BlogSection_container__G0mr8","header":"BlogSection_header___309n","headerContent":"BlogSection_headerContent__vy3kV","badge":"BlogSection_badge__tPlDb","headerText":"BlogSection_headerText__FoqMH","title":"BlogSection_title__nYNB9","description":"BlogSection_description__tVVqJ","viewAllButtonInDesktop":"BlogSection_viewAllButtonInDesktop__KbHFR","viewAllButtonInMobile":"BlogSection_viewAllButtonInMobile__Hol8O","simpleLayout":"BlogSection_simpleLayout__3LlFs","carouselWrapper":"BlogSection_carouselWrapper__0aXjS","carousel":"BlogSection_carousel__oXt2J","mobilePosts":"BlogSection_mobilePosts__aSOtt"};

/***/ })

}]);